module.exports = __webpack_public_path__ + "img/family_pic_desc_2.90b334f9.png";